export default "<h4>{{ options.templateOptions.label}}</h4>\n";